import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import Swal from "sweetalert2";
import axios from "axios";
import ReactLoading from "react-loading";
import Select from "react-select";
import PartsDetailTab from "../../components/PartsDetailTab";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import {apiCall} from "../../helpers/MainHelper";
import SearchPartsInfoOverlay from "../../components/SearchPartsInfoOverlay";

class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parts: [{ name: "",part_type: "", year: "", gen: "",car_type:"",count:4}],
      partsResults:null,
      formData:{
        year:"",
        gen:"",
        car_type:""
      },
      partData : {
        year:"",
        gen:"",
        car_type:""
      },
      isMobile:false,
      brands:[],
      models:[],
      selectedBrand:[],
      selectedModel:[],
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getBrands();
    const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
    this.setState({isMobile});
  }
  getBrands = async () => {
    const response = await apiCall('business/vehicle/get-brands', 'get', null);
    const brandOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ brands: brandOptions });
  }
  handleModelChange = async (selectedOption) => {
    //const model_id = selectedOption.value;
    const option = {
      value:selectedOption.value,
      label:selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        model: selectedOption.label
      },
      selectedModel:option,
    }));
  }
  handleBrandChange = async (selectedOption) => {
    const brand_id = selectedOption.value;
    const option = {
      value:selectedOption.value,
      label:selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        brand: selectedOption.value,
        model: ""
      },
      selectedBrand:option,
      models: []
    }));

    if (brand_id) {
      try {
        const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

        const modelOptions = response.map(model => ({
          value: model.id,
          label: model.name
        }));
        this.setState({ models: modelOptions });
      } catch (error) {
        console.error("Modelleri alırken hata oluştu:", error);
      }
    }
  }
  handleAddParts = () => {
    this.setState((prevState) => {
      if (prevState.parts.length >= 5) {
        Swal.fire({
          title: 'Limit Aşıldı!',
          text: 'Aynı ayna en fazla 5 parça sorgulayabilirsiniz.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
        return null;
      }
      return {
        parts: [
          ...prevState.parts,
          { name: "", year: this.state.formData.year, gen: this.state.formData.gen, car_type: this.state.formData.car_type, count: 4 }
        ]
      };
    });
  };

  handleRemovePart = (index) => {
    this.setState((prevState) => ({
      parts: prevState.parts.filter((_, i) => i !== index),
    }));
  };
  handlePartsChange = (index, field, value) => {
    this.setState((prevState) => {
      const updatedParts = prevState.parts.map((part, i) =>
          i === index ? { ...part, [field]: value } : part
      );

      let updatedFormData = { ...prevState.formData };
      if (field === "year" || field === "gen" || field === "car_type") {
        updatedFormData = {
          ...updatedFormData,
          [field]: value,
        };
      }

      return {
        parts: updatedParts,
        formData: updatedFormData,
      };
    });
  };

  calculatePartsCost = async () => {
    try {

      const { selectedBrand, selectedModel} = this.state;
      if (selectedBrand.length === 0 || selectedModel.length === 0) {
        Swal.close();
        Swal.fire({
          title: 'Eksik Araç Bilgisi',
          text: 'Lütfen marka ve model bilgilerini doldurun.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
        return;
      }
      for (let parts of this.state.parts) {
        if (!parts.name || !parts.year || !parts.car_type || parts.count > 5) {
          Swal.close();
          Swal.fire({
            title: 'Eksik veya Hatalı Parça Bilgisi',
            html: `
        <p>Lütfen aşağıdaki bilgileri kontrol ediniz!</p>
        <ul style="list-style-type: none">
          <li style="font-weight: bold">Parça adı boş olamaz</li>
          <li style="font-weight: bold">Model boş olamaz</li>
          <li style="font-weight: bold">Araç boş olamaz</li>
          <li style="font-weight: bold">Sorgu Adedi: Her parça için Max 5 adet olabilir.</li>
        </ul>
      `,
            icon: 'warning',
            confirmButtonText: 'Tamam'
          });
          return;
        }
      }

      Swal.fire({
        title: 'Parça Verileri Alınıyor',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const partsResults = [];

      for (let part of this.state.parts) {
        const query = `"${selectedBrand.label} ${selectedModel.label} ${part.year} ${part.gen} ${part.car_type} ${part.name}"`;
        const partInfo = await axios.post(`https://apitest.servicezone.com.tr/scrape?query=${query}&count=${part.count}&api_key=9HSXzuQpec10Skm0QoVgWYQb06wECI88`);

        const prices = partInfo.data.map(p => {
          const normalizedPrice = p.price.replace('₺', '').replace(/\./g, '').replace(',', '.');
          return parseFloat(normalizedPrice);
        });

        const averagePrice = prices.reduce((sum, price) => sum + price, 0) / prices.length;

        partsResults.push({name:part.name,count:part.count, partItems: partInfo.data, averagePrice: averagePrice.toFixed(2) });
      }

      this.setState({partsResults})
      Swal.close();

    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Hata',
        text: 'Bir sorun oluştu, lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);
    }
  };
  render() {
    const {partsResults,isMobile,selectedModel,models,selectedBrand,brands} = this.state;
    const {subscriptionCode} = this.props;
    const code = subscriptionCode !== "none" && subscriptionCode !== "t22Vh3S";
    return (
        <div style={{ flex: 1 }} onClick={() => {document.body.classList.remove("offcanvas-active");}}>
          <div>
            <div className="container-fluid">
              <PageHeader HeaderText="Servis Detayı" Breadcrumb={[
                {name: "Servisler", navigate: "services"},
                {name: "Detay", navigate: ""},
              ]}/>
              <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
                <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <div className="m-t-30">
                    <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                  </div>
                  <p>Yükleniyor</p>
                  <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="card">
                    <div className="card-body">
                        <h6 className="pr-3">İnternet Parça Arama (Beta)
                        <SearchPartsInfoOverlay></SearchPartsInfoOverlay>
                      </h6>
                      <form id="partsData">
                        <div className="row justify-content-start">

                          <div className="col-lg-6">
                            <div className="form-group">
                              <Select
                                  className="border-danger"
                                  value={selectedBrand}
                                  onChange={this.handleBrandChange}
                                  options={brands}
                                  placeholder="Marka Seçin"
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      borderColor: state.isFocused ? 'red' : 'red',
                                      boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                      '&:hover': {borderColor: 'red'}
                                    })
                                  }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <Select
                                  className="border-danger"
                                  value={selectedModel}
                                  onChange={this.handleModelChange}
                                  options={models}
                                  placeholder="Model Seçin"
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      borderColor: state.isFocused ? 'red' : 'red',
                                      boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                      '&:hover': {borderColor: 'red'}
                                    })
                                  }}
                              />
                            </div>
                          </div>
                        </div>

                        {this.state.parts.map((part, index) => (
                            <div key={index}
                                 className="form-row align-items-end mb-3">

                              <div className="col-lg">
                                <label htmlFor={`name`}>Parça Adı</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`name`}
                                    placeholder="Sol ön salıncak vs..."
                                    value={part.name}
                                    onChange={(e) => this.handlePartsChange(index, "name", e.target.value)}
                                />
                              </div>

                              <div className="col-lg">
                                <label htmlFor={`year`}>Model Yılı</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`year`}
                                    placeholder="Model Yılı"
                                    value={part.year}
                                    onChange={(e) => this.handlePartsChange(index, "year", e.target.value)}
                                />
                              </div>
                              <div className="col-lg">
                                <label htmlFor={`gen`}>Nesil</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`gen`}
                                    placeholder="F30 , Megane 4, Clio 3 , vs..."
                                    value={part.gen}
                                    onChange={(e) => this.handlePartsChange(index, "gen", e.target.value)}
                                />
                              </div>

                              <div className="col-lg">
                                <label htmlFor={`car_type`}>Araç Kasa Tipi
                                </label>
                                <select
                                    id={`car_type`}
                                    className="form-control"
                                    value={part.car_type}
                                    onChange={(e) => this.handlePartsChange(index, "car_type", e.target.value)}
                                >
                                  <option value="">Seçiniz</option>
                                  <option value="sedan">Sedan</option>
                                  <option value="hatchback">Hatchback</option>
                                  <option value="station wagon">Station Wagon</option>
                                </select>
                              </div>
                              <div className="col-lg">
                                <label htmlFor={`count`}>Sorgu Adedi</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id={`count`}
                                    value={part.count}
                                    onChange={(e) => this.handlePartsChange(index, "count", e.target.value)}
                                />
                              </div>
                              <div className={isMobile ? 'col-lg mt-2' : 'col-auto'}>
                                {index > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger w-100"
                                        onClick={() => this.handleRemovePart(index)}
                                    >
                                      -
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn btn-outline-success w-100"
                                        onClick={this.handleAddParts}
                                    >
                                      +
                                    </button>
                                )}
                              </div>
                            </div>
                        ))}

                        <div className="body">
                          <div
                              className="row clearfix justify-content-center">
                            <div className="col-lg-6 col-md-12">
                              <button

                                  onClick={this.calculatePartsCost}

                                      className="btn btn-outline-primary btn-block"
                                      type="button">
                                {code ? "Ara" : "Bu özelliği kullanmak için plan yükseltin!"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    {partsResults && (
                        <div className="body">
                          <PartsDetailTab
                              bodyData={partsResults}></PartsDetailTab>
                        </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default subscriptionPermissionsControl(connect(mapStateToProps, {})(Chat));
